import { onMounted, onUnmounted, ref } from "vue"
import { v4 as uuidv4 } from 'uuid'

export function useFlutter() {
    const isNativePlatform = ref(false)
    const isAndroid = ref(false)
    const isIos = ref(false)

    onMounted(() => {
        isNativePlatform.value = localStorage.getItem('is_native_platform') === 'yes'
        isAndroid.value = localStorage.getItem('os_platform') === 'android'
        isIos.value = localStorage.getItem('os_platform') === 'ios'
        window.addEventListener('storage', onStorageEvent)
    })
    onUnmounted(() => window.removeEventListener('storage', onStorageEvent))

    function onStorageEvent(e: StorageEvent) {
        if (e.key === 'is_native_platform') {
            isNativePlatform.value = e.newValue === 'yes'
        }
        if (e.key === 'os_platform') {
            isAndroid.value = e.newValue === 'android'
            isIos.value = e.newValue === 'ios'
        }
    }

    function postMessage(message: any) {
        try {
            // @ts-ignore
            window.FlutterChannel.postMessage(JSON.stringify(message))
        } catch {
            // Do nothing
        }
    }

    function openCamera(callback: (file: any) => void) {
        postMessage({
            type: "openCamera"
        })

        window.removeEventListener('flutterCamera', cameraEvent)
        window.addEventListener('flutterCamera', cameraEvent)

        function cameraEvent(e: any) {
            const detail = (e as CustomEvent).detail
            const { file } = JSON.parse(detail);
            window.removeEventListener('flutterCamera', cameraEvent)
            if (!file || typeof file === 'string' && file === 'null') {
                return
            }
            callback(file)
        }
    }

    function openCorrectionCamera(qntQuestions: number = 10, callback: (file: any) => void) {

        const eventName = `flutterCameraCorrection_${uuidv4}`;

        postMessage({
            type: "openCorrectionCamera",
            qntQuestions,
            eventName
        })

        window.removeEventListener(eventName, cameraEvent)
        window.addEventListener(eventName, cameraEvent)

        function cameraEvent(e: any) {
            const detail = (e as CustomEvent).detail
            const { file } = JSON.parse(detail);
            window.removeEventListener(eventName, cameraEvent)
            if (!file || typeof file === 'string' && file === 'null') {
                return
            }
            callback(file)
        }
    }

    function loginWithQrCode(email: string) {
        postMessage({
            type: "loginWithQrCode",
            email
        })
    }

    function launchUrl(url: string) {
        postMessage({
            type: "launchUrl",
            url
        })
    }

    function openCorrectionCameraV2(data: {
        organizationId: string,
        applicationId: string,
        userId: string,
        studentId: string
    }) {
        postMessage({
            type: "openCorrectionCameraV2",
            data: data
        })
    }

    return {
        isNativePlatform,
        isAndroid,
        isIos,
        openCamera,
        launchUrl,
        loginWithQrCode,
        openCorrectionCamera,
        openCorrectionCameraV2
    }
}
